import React, { SVGProps } from 'react';

export default function SvgComponent(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className="icon_reddit"
      height="1.5em"
      viewBox="0 0 24 24"
      width="1.5em"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M24 12A12 12 0 1112 0a12 12 0 0112 12z" fill="#ff4500" />
      <path
        d="M19.876 12.105a1.727 1.727 0 00-2.922-1.183A8.412 8.412 0 0012.4 9.467l.77-3.69 2.529.532a1.183 1.183 0 10.154-.721l-2.9-.579a.366.366 0 00-.438.279l-.877 4.1a8.445 8.445 0 00-4.611 1.455 1.727 1.727 0 10-1.9 2.827 3.224 3.224 0 000 .52c0 2.649 3.086 4.8 6.894 4.8s6.9-2.153 6.9-4.8a3.76 3.76 0 000-.52 1.726 1.726 0 00.955-1.565zM8.05 13.288a1.183 1.183 0 111.181 1.182 1.182 1.182 0 01-1.181-1.182zm6.871 3.283a4.516 4.516 0 01-2.922.88 4.552 4.552 0 01-2.922-.911.32.32 0 01.451-.45 3.858 3.858 0 002.459.745 3.876 3.876 0 002.473-.721.33.33 0 01.467.006.311.311 0 01-.006.451zm-.2-2.022a1.221 1.221 0 01-1.2-1.214 1.183 1.183 0 112.366 0 1.2 1.2 0 01-1.169 1.214c-.022 0 .019 0 0 0z"
        fill="#fff"
      />
    </svg>
  );
}
